"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/list/dist/mdc.list.css");
require("@rmwc/list/collapsible-list.css");
require("@rmwc/icon/styles");
require("@rmwc/ripple/styles");
